<template>
  <div>
    <Loader
      v-show="loading"
      :loading="loading"
    />
    <v-card v-if="errorException">
      <v-row
        align="center"
        class="pa-3 ma-3"
      >
        <v-icon
          small
          color="orange darken-3"
        >
          report_problem
        </v-icon>
        <span class="orange--text text--darken-3 align-center">{{
          errorException
        }}</span>
        <v-spacer />
        <IconBtn
          icons="close"
          :large="true"
          color="grey darken-4"
          @click="close"
        />
      </v-row>
    </v-card>
    <v-card v-else>
      <v-card-title>
        <v-row no-gutters>
          <span class="headline font-weight-medium">{{ header }}</span>
          <v-spacer />
          <IconBtn
            icons="close"
            :large="true"
            color="grey darken-4"
            @click="close"
          />
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <CustomTextField
              v-model="title"
              label="ФІО"
              :hide-details="true"
              :required="true"
              :error-messages="$v.title.$invalid ? errors.TITLE : []"
              @input="isChanged = true"
            />
          </v-col>
          <v-col>
            <CustomTextField
              v-model="email"
              label="Email"
              :hide-details="true"
              @input="isChanged = true"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <PrimaryBtn
          :loading="loading"
          :disabled="!isChanged || isFormInvalid"
          @click="save"
        />
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import * as employeesApi from "../../backend/employeesApi.js";
import Loader from "../../../components/Loader.vue";
import IconBtn from "../../../components/IconBtn.vue";
import PrimaryBtn from "../../../components/PrimaryBtn.vue";
import CustomTextField from "../../../components/CustomTextField.vue";
import { ERRORS } from "@/helpers";
import { required } from "vuelidate/lib/validators";

export default {
  components: {
    Loader,
    IconBtn,
    PrimaryBtn,
    CustomTextField,
  },
  props: ["id"],
  data: () => ({
    loading: false,
    errorException: "",
    isChanged: false,
    title: "",
    email: "",
  }),
  validations: {
    title: {
      required,
    },
  },
  computed: {
    isFormInvalid(){
      return this.$v.title.$invalid;
    },
    isNew() {
      return this.id != 0 ? false : true;
    },
    header() {
      return this.isNew ? "Створення співробітника" : "Редагування співробітника";
    },
    errors() {
      return {
        TITLE: [ERRORS.REQUIRED],
        PARTNERSHIP_STOPPED: [ERRORS.REQUIRED],
        PARTNERSHIP_STOPPED_DATE: [ERRORS.REQUIRED],
        PARTNERSHIP_STOPPED_REASON: [ERRORS.REQUIRED],
        CRM: [ERRORS.REQUIRED],
        EMAIL: [ERRORS.EMAIL],
      };
    },
  },
  created() {
    if (this.id != 0) {
      employeesApi.getEmployee(this.id).then((issue) => {
        this.title = issue.title;
        this.email = issue.email;
      });
    }
  },
  methods: {
    async save() {
      this.loading = true;
      if (this.id == 0) {
        await employeesApi
          .createEmployee({ title: this.title, email: this.email })
          .then(() => {
            this.$router.push({ path: "/crm-employees" });
          });
      } else {
        await employeesApi.updateEmployee(this.id, {
          title: this.title,
          email: this.email,
        });
        this.$notifySuccess();
      }
      this.loading = false;
    },
    close() {
      if (this.modal) {
        this.$emit("close");
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>